import { render, staticRenderFns } from "./ContainerFR.vue?vue&type=template&id=3523ca0f&scoped=true"
import script from "./ContainerFR.vue?vue&type=script&lang=js"
export * from "./ContainerFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523ca0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3523ca0f')) {
      api.createRecord('3523ca0f', component.options)
    } else {
      api.reload('3523ca0f', component.options)
    }
    module.hot.accept("./ContainerFR.vue?vue&type=template&id=3523ca0f&scoped=true", function () {
      api.rerender('3523ca0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ContainerFR.vue"
export default component.exports